module.exports = __webpack_public_path__ + "img/strelkov.0cfa7f25.png";